import axios from '../utils/axios';

export default function fetchTagsCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/tags-count', { params })
    )
}
